/*eslint-disable */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

interface DatosComponentProps {
  modelo: any;
  version: any;
  cuotaInicial: any;
  plazo: any;
  frecuenciaPago: any;
  diaPago: any;
  tipoPlan: any;
  cuotaExtra: any;
  amortizationData: any;
  vehiculos: any;
  setSend: any
}

const AmortizacionComponent: React.FC<DatosComponentProps> = ({
  modelo,
  version,
  cuotaInicial,
  plazo,
  frecuenciaPago,
  diaPago,
  tipoPlan,
  cuotaExtra,
  amortizationData,
  vehiculos,
  setSend
}) => {
  const [data, setData] = useState<any[]>([]);
  const [headers, setHeaders] = useState<string[]>([]);
  const [totalRow, setTotalRow] = useState<any>({});

  useEffect(() => {
    if (amortizationData?.PlanDePagoTotal?.length > 0) {
      const planData = amortizationData.PlanDePagoTotal;
      setData(planData); // Almacena los datos en el estado
      setHeaders(Object.keys(planData[0])); // Extrae los headers

      // Calcula el total para cada columna numérica
      const totals: any = {};
      headers.forEach((header) => {
        totals[header] = planData.reduce((sum: any, item: any) => {
          const value = Number(item[header]);
          return !isNaN(value) ? sum + value : sum;
        }, 0);
      });
      setTotalRow(totals);
    }
  }, [amortizationData, headers]);

  const formatCurrency = (value: any) => {
    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
    }).format(value);
  };

  const formatDate = (date: string | Date): string => {
    const parsedDate = new Date(date); // Convierte el valor a una fecha
    if (isNaN(parsedDate.getTime())) return String(date); // Devuelve el valor original como string si no es una fecha válida

    return parsedDate.toLocaleDateString("es-CO", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <>
      <div className="title-amortizacion-simulador-component">
        <div className="bttn" onClick={() => setSend(false)}>Volver</div>
        <div className="title">
          Simulador de cuotas
        </div>
      </div>
      <div className="amortizacion-simulador-component">
        <div className="detalle-amortizacion-simulador-component">
          <div className="subTitle">Detalle de pagos</div>
          <div className="title">{vehiculos?.find((item: any) => item.slug === modelo)?.name} {version}</div>
          <div className="labels">
            <div className="label">Precio desde</div>
            <div className="labelData">{formatCurrency(vehiculos?.find((item: any) => item.slug === modelo)?.versions?.find((e: any) => e.name === version)?.price)}</div>
          </div>
          <div className="labels">
            <div className="label">Cuota inicial</div>
            <div className="labelData">{formatCurrency(cuotaInicial)}</div>
          </div>
          <div className="labels">
            <div className="label">Capital inicial</div>
            <div className="labelData">{formatCurrency(vehiculos?.find((item: any) => item.slug === modelo)?.versions?.find((e: any) => e.name === version)?.price - cuotaInicial)}</div>
          </div>
          <div className="labels">
            <div className="label">Seguro de vida</div>
            <div className="labelData">
              {formatCurrency(amortizationData?.ValorSeguroVida)}
            </div>
          </div>
          <div className="labels">
            <div className="label">Plazo de</div>
            <div className="labelData">
              {plazo} cuotas{" "}
              {frecuenciaPago === "m"
                ? "mensuales"
                : frecuenciaPago === "s"
                  ? "semanales"
                  : ""}
            </div>
          </div>
          <Link to={`/vehiculos/${vehiculos?.find((item: any) => item.slug === modelo)?.slug}#cotizacion`} className="btn-cotizacion">Realizar una cotización</Link>
          <Link to={"/simulador-de-cuotas"} onClick={() => window.location.reload()} className="btn-simulacion">Realizar otra simulación</Link>
        </div>
        <div className="pagos-amortizacion-simulador-component">
          <div className="subTitle">Plan de pagos</div>
          <div style={{ overflow: "auto" }}>
            <table
              border={1}
              style={{ borderCollapse: "collapse", width: "100%", minWidth: "950px" }}
              className="tabla-pagos-amortizacion-simulador-component"
            >
              <thead>
                <tr className="cabecera">
                  {headers.map((header, index) => (
                    header !== "CuotaExtra" && header !== "ValorCuotaFinal" ? <th
                      key={header}
                      style={{
                        position: index === 0 ? "sticky" : "static",
                        left: index === 0 ? 0 : "auto",
                        top: 0,
                        backgroundColor: "#002C5F",
                        borderColor: "transparent",
                        zIndex: 2,
                        padding: "8px",
                      }}
                    >
                      {header === "Secuencia"
                        ? "Cuota"
                        : header === "FechaPago"
                          ? "Fecha de pago"
                          : header === "ValorCuota"
                            ? "Valor cuota"
                            : header === "Interes"
                              ? "Interés"
                              : header === "AbonoCapital"
                                ? "Abono capital"
                                : header === "CapitalInical"
                                  ? "Capital Inicial"
                                  : header === "CapitalFinal"
                                    ? "Capital final"
                                    : header === "CuotaExtra"
                                      ? "Cuota extra"
                                      : header === "ValorCuotaFinal"
                                        ? "Valor cuota final"
                                        : ""}
                    </th> : null
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.map((row, rowIndex) => (
                  <tr key={rowIndex} className="contenido-table">
                    {headers.map((header, colIndex) => (
                      header !== "CuotaExtra" && header !== "ValorCuotaFinal" ? <td
                        key={colIndex}
                        style={{
                          position: colIndex === 0 ? "sticky" : "static",
                          borderColor: "transparent",
                          left: colIndex === 0 ? 0 : "auto",
                          backgroundColor:
                            rowIndex % 2 === 0 ? "#f9f9f9" : "#fff",
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        {colIndex === 0
                          ? "Mes " + row[header]
                          : colIndex === 1
                            ? formatDate(row[header]) // Formatea la segunda columna
                            : formatCurrency(row[header])}
                      </td> : null
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default AmortizacionComponent;
